export default {
    payments: {
        title: 'Data',
        options: {
            monthly: {
                title: 'Monthly',
            },
            quarterly: {
                title: 'Quarterly',
            },
            annual: {
                title: 'Annual',
            },
        },
    },
};
